/* eslint-disable max-len */
export const isCurrentDateEqualOrLessThanGivenDate = (givenDateString: string): boolean => {
    const currentDate = new Date();
    let givenDate: Date;

    // Check if the string is in ISO format (contains 'T' and 'Z')
    if (givenDateString.includes('T')) {
        // Parse as ISO string
        givenDate = new Date(givenDateString);
    } else {
        // Parse using the original format
        const [year, month, day, hours, minutes, seconds] = givenDateString.split(/[- :]/);
        givenDate = new Date(Number(year), Number(month) - 1, Number(day), Number(hours), Number(minutes), Number(seconds));
    }

    const result = currentDate <= givenDate;
    return result;
};
